window.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector(".popup404");
  const dismiss = document.querySelector(".dismiss-404-js");
  const isFrom404 = localStorage.getItem("isFrom404");
  
  if (!isFrom404) return;

  setTimeout(() => {
    popup.classList.remove("none");

    dismiss.addEventListener("click", () => {
      popup.classList.add("none");
      localStorage.removeItem("isFrom404");
    });
  }, 300);
});